import { RxAxios } from 'api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export namespace GeoIpService {
  interface Response {
    country: string;
  }

  const client = new RxAxios({
    options: {
      baseURL: 'https://get.geojs.io/',
    },
  });

  export const getCountryByIp = (): Observable<String> => {
    return client.get<Response>(`/v1/ip/country.json`).pipe(map((it) => it.country));
  };
}
